import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title = "Suraj Sahani - Full Stack Developer | React, Next.js, Node.js Expert | Educator",
  description = "Passionate Full Stack Developer & Educator with 1000+ students trained. Expert in React.js, Next.js, Node.js, Spring Boot, Django, PostgreSQL, AI/ML. Solved 1000+ LeetCode problems.",
  keywords = "Suraj Sahani, Full Stack Developer, React Developer, Next.js, Node.js, Spring Boot, Django, PostgreSQL, IT Trainer, Software Engineer, LeetCode Expert, Octalogic Tech, AI ML Developer, MERN Stack Developer",
  author = "Suraj Sahani",
  type = "website",
  image = "https://engineersurajsahani.netlify.app/surajsahani_softwaredeveloper.jpeg",
  url = "https://engineersurajsahani.netlify.app/"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

// Section-specific SEO configurations
export const seoConfigs = {
  home: {
    title: "Suraj Sahani - Full Stack Developer | React, Next.js, Node.js Expert | Educator | Portfolio",
    description: "Passionate Full Stack Developer at Octalogic Tech. Trained 1000+ students. Expert in React.js, Next.js, Node.js, Spring Boot, Django, PostgreSQL, AI/ML. Solved 1000+ coding problems.",
    keywords: "Suraj Sahani, Full Stack Developer, Software Engineer, React Developer, Node.js Developer, Next.js, Spring Boot Developer, Django Developer, PostgreSQL Expert, MongoDB, IT Trainer, LetsUpgrade, Octalogic Tech, AI ML Developer, Computer Vision, Web Application Architecture"
  },
  about: {
    title: "About Suraj Sahani - Full Stack Developer & Educator",
    description: "Learn about Suraj Sahani, a passionate Full Stack Developer and Educator with expertise in modern web technologies. Started coding journey in 2020, now working at Octalogic Tech and training 1000+ students.",
    keywords: "About Suraj Sahani, Full Stack Developer Background, IT Trainer, Software Engineer Experience, React Expert, Node.js Specialist, AI ML Developer"
  },
  skills: {
    title: "Technical Skills - Suraj Sahani | Full Stack Development Expertise",
    description: "Comprehensive technical skills including React.js, Next.js, Node.js, Express.js, Spring Boot, Django, PostgreSQL, MongoDB, AI/ML, Computer Vision, and Cloud Computing. Proficient in HTML, CSS, JavaScript, Python, Java, and more.",
    keywords: "Technical Skills, React.js, Next.js, Node.js, Express.js, Spring Boot, Django, PostgreSQL, MongoDB, Python, Java, JavaScript, AI ML, Computer Vision, Full Stack Technologies"
  },
  experience: {
    title: "Professional Experience - Suraj Sahani | Full Stack Developer at Octalogic Tech",
    description: "Professional journey as Full Stack Developer at Octalogic Tech, IT Trainer at LetsUpgrade, Disha Computer Institute, Effilearn, and Assistant Professor. Trained 1000+ students in programming.",
    keywords: "Professional Experience, Octalogic Tech, Full Stack Developer, IT Trainer, LetsUpgrade, Disha Computer Institute, Assistant Professor, External Examiner, Technical Training"
  },
  projects: {
    title: "Projects Portfolio - Suraj Sahani | Web Applications & AI/ML Solutions",
    description: "Explore diverse portfolio of projects including Computer Engineering Education Portal, Library Management System, E-Granthalaya, Wedding Planner, Blog Applications, YouTube Clone built with React, Django, Node.js, and more.",
    keywords: "Projects Portfolio, Web Applications, Django Projects, React Projects, Node.js Applications, AI ML Projects, Computer Vision, Predictive Models, Full Stack Projects"
  },
  education: {
    title: "Education - Suraj Sahani | Computer Engineering Graduate",
    description: "Bachelor's Engineering in Computer Engineering from Lokmanya Tilak College Of Engineering, Mumbai University. Strong academic background with 8.68 CGPA.",
    keywords: "Education, Computer Engineering, Mumbai University, Lokmanya Tilak College, Engineering Graduate, Academic Background"
  },
  contact: {
    title: "Contact Suraj Sahani - Full Stack Developer | Let's Collaborate",
    description: "Get in touch with Suraj Sahani for Full Stack Development projects, IT Training, Technical Consulting, or collaboration opportunities. Available for freelance and full-time opportunities.",
    keywords: "Contact, Hire Full Stack Developer, IT Training Services, Technical Consulting, Collaboration, Freelance Developer, Navi Mumbai Developer"
  }
};
